import React, { useCallback } from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { PsychologyReverse } from "assets/material-custom-icons";
import { DocumentSectionType } from "constants/documents";
import { useRoleGuardHook } from "hooks";
import { useDealActions, useDocumentsActions } from "store";
import { DocumentSectionFile } from "store/types";

import { RoleName } from "../../../constants";
import { useContentContext } from "../Content/content-context";
import { FileBlock } from "../FileBlock/FileBlock";

interface FileSectionProps {
  section: DocumentSectionFile | null;
  onDelete: () => void;
  onFocus?: () => void;
}

export const FileSection: React.FC<FileSectionProps> = ({ section, onDelete, onFocus }) => {
  if (!section) return null;

  const { file, id, document_id } = section;
  if (!file) return null;

  const { downloadFileAction } = useDealActions();
  const { downloadDocumentFileAction } = useDocumentsActions();
  const { updateSection, createQuestion } = useContentContext();

  const enabled = useRoleGuardHook(true, [RoleName.Admin, RoleName.Analyst]);
  const enabledOption = useRoleGuardHook(true, [RoleName.Admin, RoleName.Analyst, RoleName.Guest]);

  const onDownload = () => {
    if (file.deal_id) {
      downloadFileAction({ fileId: file.id, fileName: file.name, dealId: file.deal_id });
    } else {
      file.document_id && downloadDocumentFileAction({ documentId: file.document_id, fileId: file.id });
    }
  };

  const handleAskAi = useCallback(async () => {
    await updateSection({ id, type: DocumentSectionType.AIFile });
    createQuestion({ documentId: document_id, section_id: id });
  }, [id, document_id, createQuestion]);

  return (
    <FileBlock
      file={file}
      showMenu={!!enabledOption}
      onFocus={onFocus}
      menuOptions={[
        {
          title: "Download",
          icon: <FileDownloadOutlinedIcon sx={{ color: "#0a3142" }} fontSize="md" />,
          onClick: onDownload
        },
        {
          title: "Ask AI",
          icon: <PsychologyReverse sx={{ fill: "#0a3142" }} fontSize="md" />,
          onClick: handleAskAi,
          disabled: file.state === "scanning",
          hidden: !enabled
        },
        {
          title: "Delete",
          icon: <DeleteOutlineIcon sx={{ color: "#0a3142" }} fontSize="md" />,
          onClick: onDelete,
          hidden: !enabled
        }
      ]}
    />
  );
};
